import * as React from 'react'
import { ConfirmModal } from '../../../modals/ConfirmModal'
import ContractModal from '../../../modals/contract/ContractModal'
import { DriverFormProvider } from '../../../context/DriverFormContext'
import AddDriverModal from '../../../modals/driverAdd/AddDriverModal'
import { ContractFormProvider } from '../../../context/ContractFormContext'
import { useModals } from '@/modules/drivers/stores/modalsStore'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import useDriverService from '../../../services/DriverService'
import { SelectionGroup } from '../../../context/TableContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useSideSelectionStore } from '@/modules/drivers/stores/sideSelectionStore'

const ModalsContainer = ({
  driverId,
  companyId,
  contractId,
  selectedDriverNames,
  lastAnnexDate,
  selectedContractId,
  selectedGroupOverride,
  onResetOverride,
}: {
  driverId?: number
  companyId: string
  contractId?: string
  selectedDriverNames: string[]
  lastAnnexDate?: string
  selectedContractId?: string
  selectedGroupOverride?: SelectionGroup
  onResetOverride?: () => void
}) => {
  const { t } = useLocalize()
  const { refresh } = useDrivers()
  const { sideCheckedIds, sideIsActive, clearSide } = useSideSelectionStore()
  const { activateDriver } = useDriverService()

  const sideSelectedGroup: SelectionGroup =
    sideCheckedIds.length > 0
      ? { ids: sideCheckedIds, isActive: sideIsActive }
      : null
  const selectedGroup =
    selectedGroupOverride !== undefined
      ? selectedGroupOverride
      : sideSelectedGroup
  const resetAll = onResetOverride ?? clearSide

  const {
    isOpenEditDriverModal,
    setIsCreateContractOpen,
    isCreateContractOpen,
    isCreateAnnexOpen,
    setIsCreateAnnexOpen,
    setIsOpenEditDriverModal,
    isDeactivateOpen,
    setIsDeactivateOpen,
    isAnnexOpen,
    setIsAnnexOpen,
  } = useModals()

  const closeDeactivate = () => setIsDeactivateOpen(false)
  const handleDeactivateConfirm = async () => {
    await activateDriver({
      driversIds: selectedGroup?.ids,
      companyId,
      setActive: false,
    })
    refresh()
    resetAll()
    closeDeactivate()
  }
  const isMoreThanOne = selectedDriverNames.length > 1
  return (
    <>
      {isDeactivateOpen && (
        <ConfirmModal
          isOpen={isDeactivateOpen}
          onClose={closeDeactivate}
          title={t('driverModule.deactivation')}
          actionText={t('driverModule.deactivate')}
          text={t('driverModule.confirm-deactivate')}
          onConfirm={handleDeactivateConfirm}
          content={selectedDriverNames}
        />
      )}
      {isAnnexOpen && contractId && (
        <ContractFormProvider
          companyId={companyId}
          driverId={isMoreThanOne ? undefined : driverId || selectedGroup?.ids[0]}
          contractId={selectedContractId || contractId}
          isAnnex={true}
          lastAnnexDate={lastAnnexDate}
        >
          <ContractModal
            contractId={selectedContractId || contractId}
            driversId={
              isMoreThanOne
                ? selectedGroup.ids
                : driverId || selectedGroup?.ids[0]
            }
            companyId={companyId}
            driverNames={
              isMoreThanOne ? selectedDriverNames : [selectedDriverNames[0]]
            }
            close={() => {
              setIsAnnexOpen(false)
            }}
          />
        </ContractFormProvider>
      )}
      {isCreateContractOpen && (
        <ContractFormProvider
          companyId={companyId}
          driverId={isMoreThanOne ? undefined : driverId || selectedGroup?.ids[0]}
        >
          <ContractModal
            driversId={
              isMoreThanOne
                ? selectedGroup.ids
                : driverId || selectedGroup?.ids[0]
            }
            companyId={companyId}
            driverNames={
              isMoreThanOne ? selectedDriverNames : [selectedDriverNames[0]]
            }
            close={() => {
              setIsCreateContractOpen(false)
            }}
          />
        </ContractFormProvider>
      )}
      {isCreateAnnexOpen && (
        <ContractFormProvider
          companyId={companyId}
          driverId={isMoreThanOne ? undefined : driverId || selectedGroup?.ids[0]}
          isAnnex={true}
        >
          <ContractModal
            driversId={
              isMoreThanOne
                ? selectedGroup.ids
                : driverId || selectedGroup?.ids[0]
            }
            companyId={companyId}
            driverNames={
              isMoreThanOne ? selectedDriverNames : [selectedDriverNames[0]]
            }
            close={() => {
              setIsCreateAnnexOpen(false)
            }}
          />
        </ContractFormProvider>
      )}
      {isOpenEditDriverModal && (
        <DriverFormProvider
          companyId={companyId}
          isEdit={true}
          driverId={selectedGroup.ids[0] || null}
        >
          <AddDriverModal
            companyId={companyId}
            isOpen={isOpenEditDriverModal}
            close={() => setIsOpenEditDriverModal(false)}
          />
        </DriverFormProvider>
      )}
    </>
  )
}

export default ModalsContainer
